import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { BroadcastStatus } from '../../../../../types';
import { BroadcastViewState, VHLivePostMessageEvent } from '../../../types';

export const vhLivePostMessageEvent = createAction<VHLivePostMessageEvent>('broadcastViewer/vhLivePostMessageEvent');

const initialState: BroadcastViewState = {
    status: BroadcastStatus.NONE,
    caption: '',
};

const broadcastViewSlice = createSlice({
    name: 'broadcastViewer',
    initialState,
    reducers: {
        updateViewerState(state: BroadcastViewState, action: PayloadAction<Partial<BroadcastViewState>>) {
            return {
                ...state,
                ...action.payload,
            };
        },
    },
});

export const { updateViewerState } = broadcastViewSlice.actions;
export const strmPlayerViewingEndedAction = createAction('broadcastViewer/strmPlayerViewingEndedAction');

export default broadcastViewSlice.reducer;
